import { useContext, useMemo } from "react";
import { useConfigurationLanguage, useCsAttribute, } from "@plansoft-configuration-renderer/framework";
import { ControlLayoutContext } from "@plansoft-configuration-renderer/layout";
import { defaultAttributeDisplayOptions, } from "../Attributes/AttributeDisplayOptions";
import { createValueSortFunction } from "./helpers/createValueSortFunction";
const DEFAULT_OPTIONS = {
    includeEditable: false,
};
/**
 * Returns list of visible values
 * - requires {@linkcode CsAttributeController}
 * - removes values with `isAllowed=false`
 * - if `showDisallowedValues=true`, all values are shown
 * - sorts values according to layout settings
 *
 * @category Hook
 * @category CsAttribute
 * @export
 * @returns  Returns list of visible values
 */
export function useVisibleAttributeValues(options = DEFAULT_OPTIONS) {
    const { includeEditable } = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    const attribute = useCsAttribute();
    const controlProps = useContext(ControlLayoutContext);
    const localeCode = useConfigurationLanguage();
    // cast to presumed type
    const { showDisallowedValues = false, valueSorting = defaultAttributeDisplayOptions.valueSorting, } = controlProps;
    const valueSortFunction = useMemo(() => createValueSortFunction(valueSorting, { localeCode }), [valueSorting, localeCode]);
    return useMemo(() => {
        if (!attribute.values) {
            return [];
        }
        // remove editable and disallowed values
        const visibleAttributes = attribute.values.filter((v) => (includeEditable || !v.isEditable) &&
            (showDisallowedValues || v.isAllowed));
        return valueSortFunction(visibleAttributes);
    }, [
        attribute.values,
        includeEditable,
        showDisallowedValues,
        valueSortFunction,
    ]);
}
//# sourceMappingURL=useVisibleAttributeValues.js.map